
export const upgradeMessages = [
    "Upgrade to 500GB of Optimized Music & File Storage on OmMuse Major",
    "Click here to upgrade to OmMuse Major for 500GB of Optimized Music & File Storage",
    "Upgrade to 1TB of Optimized Music & File Storage on OmMuse Studio",
    "Click here to upgrade to OmMuse Studio for 1TB of Optimized Music & File Storage",
    "Get discounted Dolby.io AI mastering by upgrading to OmMuse Major",
    "Get discounted Dolby.io AI mastering by upgrading to OmMuse Studio",
    "Click here to upgrade to OmMuse Major for discounted Dolby.io AI Mastering",
    "Click here to upgrade to OmMuse Studio for discounted Dolby.io AI Mastering",
    "Get discounted smart contract minting by upgrading to OmMuse Major",
    "Get discounted smart contract minting by upgrading to OmMuse Studio",
    "Click here to upgrade to OmMuse Major for discounted smart contract minting",
    "Click here to upgrade to OmMuse Studio for discounted smart contract minting",
    "Get your profile & music added to our Featured Section by upgrading to OmMuse Studio",
    "Click here to upgrade to OmMuse Studio to get your profile & music added to our Featured Section",
    "Elevate your experience by upgrading to OmMuse Major or Studio",
    "Click here to upgrade to OnMuse Major or Studio for an elevated experience",
    "Unlock additional features by upgrading to OnMuse Major or Studio",
    "Click here to upgrade to OmMuse Major or Studio for to unlock additional features",
    "Increase your music & profile visibility by upgrading to OmMuse Studio",
    "Click here to upgrade to OmMuse Studio and increase your music & profile visibility"
  ];
  